import { Card, CardContent } from "../ui/card";
import type { TicketStats } from "../../services/ticketsService";

function StatTile({ label, value }: { label: string; value: string | number }) {
  return (
    <Card>
      <CardContent className="py-4">
        <div className="text-2xl font-semibold">{value}</div>
        <div className="text-xs text-muted-foreground">{label}</div>
      </CardContent>
    </Card>
  );
}

function horas(v: number | null) {
  if (v === null || v === undefined) return "—";
  if (v < 1) return `${Math.round(v * 60)} min`;
  return `${v} h`;
}

export function TicketStatsPanel({ stats }: { stats: TicketStats }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <StatTile label="Tickets este mes" value={stats.tickets_mes_actual} />
      <StatTile label="Resueltos este mes" value={stats.tickets_resueltos_mes_actual} />
      <StatTile label="Tiempo de respuesta prom." value={horas(stats.tiempo_respuesta_promedio_horas)} />
      <StatTile label="Tiempo de resolución prom." value={horas(stats.tiempo_resolucion_promedio_horas)} />
    </div>
  );
}
